import { render } from "./reg-grid.vue?vue&type=template&id=f9caa488"
import script from "./reg-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./reg-grid.vue?vue&type=script&setup=true&lang=js"

import "./reg-grid.vue?vue&type=style&index=0&id=f9caa488&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/virtual/reg-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9caa488"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9caa488', __exports__)) {
    api.reload('f9caa488', __exports__)
  }
  
  module.hot.accept("./reg-grid.vue?vue&type=template&id=f9caa488", () => {
    api.rerender('f9caa488', render)
  })

}


export default __exports__